module.exports = __webpack_public_path__ + "static/media/owl-accept-proposal.754ded6a.svg";